import cn from "classnames"

import s from "./Burger.module.scss"

type BurgerProps = {
  active?: boolean
  controls?: string
  onClick?: () => void
  className?: string
}

export const Burger = ({
  active,
  controls,
  onClick,
  className,
}: BurgerProps) => {
  return (
    <button
      type="button"
      aria-label={active ? "Close main menu" : "Open main menu"}
      aria-expanded={active}
      aria-controls={controls}
      data-active={active}
      data-element="burger"
      className={cn(s.burger, className)}
      onClick={onClick}
    >
      <span />
    </button>
  )
}
